// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2HWNV","productName":"Table_productName__3Bb6o"};